import { render, staticRenderFns } from "./HomeHeading.vue?vue&type=template&id=2260c0b2&scoped=true"
import script from "./HomeHeading.vue?vue&type=script&lang=js"
export * from "./HomeHeading.vue?vue&type=script&lang=js"
import style0 from "./HomeHeading.vue?vue&type=style&index=0&id=2260c0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2260c0b2",
  null
  
)

export default component.exports